module.exports = __webpack_public_path__ + "static/media/高分一号02星.21a77d92.png";